// extracted by mini-css-extract-plugin
export var childrenContainer = "_4k-0";
export var virtualScrollArea = "_4k-1";